module.exports = "<h3 class=\"d-flex justify-content-center\">\r\n    {{ errorMessage }}\r\n</h3>"